// FROM: https://github.com/modusign/modusign-client/blob/1f2cc00e317b3cc6ddf42ace319c72036470a423/app/src/components/UniversalTextField/FontSizeNormalizer/index.jsx

import { ReactNode } from 'react';

const defaultProps = {
  baseFontSize: 60,
  fontSize: 12,
};

interface FontSizeNormalizerProps {
  baseFontSize: number;
  fontSize: number;
  render: (
    style: Pick<React.CSSProperties, 'fontSize' | 'display' | 'height' | 'width'>
  ) => ReactNode;
}

/**
 * 브라우저의 한계로 fontSize 속성으로는 10px 이하의 fontSize를 표현할 수 없어
 * 크게 렌더링한 텍스트 박스를 transform scale을 통해 원하는 폰트사이즈로 자식 노드를 표현해주는 컴포넌트입니다.
 * 컨테이너의 크기는 부모의 크기를 따릅니다. (width: 100%, height: 100%)
 */
function FontSizeNormalizer(props: FontSizeNormalizerProps) {
  const { baseFontSize, render, fontSize } = props;

  const containerStyle = {
    /**
     * calc를 이용해 원하는 fontSize와 baseFontSize의 비율로 크기를 적용합니다.
     */
    width: `calc(100% * ${baseFontSize / fontSize})`,
    height: `calc(100% * ${baseFontSize / fontSize})`,
    /**
     * scale로 원하는 fontSize 크기로 재조정합니다.
     */
    transform: `scale(${fontSize / baseFontSize})`,
    transformOrigin: 'left top',
  };

  const style = {
    fontSize: `${baseFontSize}px`,
    display: 'inline-block',
    height: '100%',
    width: '100%',
  };

  return (
    <div
      className="FontSizeNormalizer"
      style={{
        display: 'inline-block',
        height: '100%',
        overflow: 'hidden',
        // INFO(@DevSDK): Chrome 93 버전에서 텍스트 입력 레이아웃의 위치가 어긋나는 이슈가 발생했습니다.
        // 이는 Chromium의 LayoutNG, Viz, Composition After Paint, 혹은 레이아웃 관련 최적화 코드의 추가로 인해 Layout
        // 계층에서 부모 엘리먼트의 위치에 대한 행렬 연산이 적용되지 않고 생략되거나 무시되어서 발생한 이유로 추정됩니다. (혹은 Fragment)
        // 이를 해결하기 위해 textarea의 부모 엘리먼트에 transformation operation을 추가합니다.
        // Chrome 94 버전에서 해결이 확인되며, 94 stable 배포 이후 재검토가 필요합니다.
        transform: 'scale(1)',
        width: '100%',
      }}
    >
      <div className="FontSizeNormalizer__container" style={containerStyle}>
        {render(style)}
      </div>
    </div>
  );
}
FontSizeNormalizer.defaultProps = defaultProps;

export default FontSizeNormalizer;
